import { memo, useMemo } from 'react'
import { useInView } from 'react-intersection-observer'
import { StickyHeader } from 'client/components/Gallery/Header/StickyHeader'
import { StaticHeader } from 'client/components/Gallery/Header/StaticHeader'
import { galleryHeaderId } from 'client/components/Gallery/Header/constants'

import { FilterMenu } from 'client/components/Gallery/Header/FilterMenu'
import { SearchBox } from 'client/components/Gallery/Header/Searchbox'
import { FavoritesCTA } from 'client/components/Gallery/Header/Favorites'
import { useShowFavorites } from 'client/hooks/useShowFavorites'
import { usePersonalizationConfig, MobileModalOpenButton } from 'client/components/Gallery/DesignPersonalization'

export const Header = memo(() => {
  const { ref: headerRef, inView, entry } = useInView()
  const headerIsVisible = useMemo(() => inView || !entry, [inView, entry])

  const showFavorites = useShowFavorites()
  const { isEnabled, mode, imageCopyKey } = usePersonalizationConfig()

  const showPersonalization = isEnabled && mode === 'modal'
  const HeaderWrapper = headerIsVisible ? StaticHeader : StickyHeader

  return (
    <div className="gallery-header" id={galleryHeaderId} ref={headerRef}>
      <HeaderWrapper>
        <div className="subheader-actions">
          <SearchBox />
          {showFavorites && <FavoritesCTA userInteractionLocation="staticHeader" />}
          <FilterMenu shouldRenderSmallMobileIcon={showPersonalization} showColorFilterFirst={showPersonalization && imageCopyKey !== 'Photo'} />
          {showPersonalization && <MobileModalOpenButton />}
        </div>
      </HeaderWrapper>
    </div>
  )
})

Header.displayName = 'Header'
